/**
 * useDeferredReady — returns `false` for `delayMs` after mount, then `true`.
 *
 * Used to defer low-priority feeds so they don't fire on first paint.
 * On first load the dashboard fires 33 useFeed calls in parallel; the
 * 24h-TTL reference feeds (municipality profile, attractions, moph-health)
 * are the lowest priority and the heaviest in payload. Deferring them
 * by 800ms lets the map and the water-security hero paint first, after
 * which the user sees a quiet background refresh.
 *
 * The hook is intentionally trivial — we want a one-line "is it time
 * yet?" check, not a full deferred-data abstraction.
 */

import { useEffect, useState } from "react";

export function useDeferredReady(delayMs: number): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setReady(true), delayMs);
    return () => window.clearTimeout(t);
  }, [delayMs]);
  return ready;
}
